import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useRef, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import cx from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import Checkbox from 'ui/components/checkbox';
import DataTable from '../ui/table';
import Input from '../ui/input-auto-complete';
import ModalDialog from '../ui/modal-dialog';
import Form from '../ui/form'; //api

import { editMessageTypeAPI } from '../../api/messageAPI'; // redux

import { setMessageTypeList, clearDialogInfo } from '../../redux/live-message';
var t = i18n.getFixedT(null, 'live-message');
var gt = i18n.getFixedT(null, 'app');
var et = i18n.getFixedT(null, 'errors');
var EventTypeEdit = /*#__PURE__*/React.memo(function (props) {
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$liveMess = _useSelector.liveMessage.dialogInfo,
      mode = _useSelector$liveMess.mode,
      data = _useSelector$liveMess.data;

  var dispatch = useDispatch();
  var id = props.id;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      messageTypeData = _useState2[0],
      setMessageTypeData = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var form_ref = useRef(null);
  if (mode.indexOf('messageType') < 0) return null;

  var handleClose = function handleClose() {
    dispatch(clearDialogInfo());
    setMessageTypeData([]);
    setError(null);
  };

  var handleChange = function handleChange(id, path, val) {
    var newData = _.cloneDeep(messageTypeData.length > 0 ? messageTypeData : data);

    var item = _.filter(newData, function (e) {
      return e.id === id;
    })[0];

    _.set(item, path, val);

    if (item.autoUnpublish === false && path === 'autoUnpublishAfterStart') _.set(item, 'autoUnpublish', true);
    if (val === false && path === 'autoUnpublish') _.set(item, 'autoUnpublishAfterStart', -1);
    setMessageTypeData(newData);
  };

  var handleConfirm = function handleConfirm() {
    if (messageTypeData.length === 0) handleClose(); // check fill required

    var fillOutRequired = [];

    _.forEach(messageTypeData, function (item) {
      if (item.autoUnpublish === true && item.autoUnpublishAfterStart === -1) fillOutRequired.push(item.name);
    });

    if (fillOutRequired.length > 0) return setError(t('txt-fill-time', {
      type: _.join(fillOutRequired, ', ')
    }));

    _.forEach(messageTypeData, function (item) {
      if (item.autoUnpublish === false) {
        item.autoUnpublishAfterStart = -1;
      }

      delete item.autoUnpublish;
    });

    editMessageTypeAPI(contextRoot, false, messageTypeData).then(function (result) {
      dispatch(setMessageTypeList(messageTypeData));
      handleClose();
    }).catch(function (error) {
      setError(error.message);
    });
  };

  var actions = {};

  _.set(actions, 'cancel', {
    text: gt('global.lbl-answer-cancel'),
    handler: handleClose
  });

  _.set(actions, 'confirm', {
    text: gt('global.lbl-answer-ok'),
    className: 'button-success',
    handler: handleConfirm
  });

  var fields = {};

  _.set(fields, 'authorizations', {
    label: '',
    editor: EventTypeList,
    props: {
      typeList: messageTypeData.length > 0 ? messageTypeData : data,
      onDataChange: handleChange
    }
  });

  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: id,
    title: t('dlg-message-type-setting'),
    global: true,
    info: error,
    infoClassName: cx({
      'c-error': error
    }),
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement(Form, {
    id: "".concat(id, "-form-left"),
    ref: form_ref,
    className: "pure-form-aligned",
    fieldClassName: "pure-control-group",
    fields: fields,
    onChange: handleChange // value={data}

  }));
});
EventTypeEdit.defaultProps = {
  id: 'g-liveMessage-type-edit'
};
EventTypeEdit.propTypes = {
  id: PropTypes.string
};
export default EventTypeEdit;
var EventTypeList = /*#__PURE__*/React.memo(function (props) {
  var onDataChange = props.onDataChange,
      typeList = props.typeList;

  var handleChange = function handleChange(id, path, value) {
    onDataChange(id, path, value);
  };

  var fields = {};

  _.set(fields, 'name', {
    label: t('lbl-message-type')
  });

  _.set(fields, 'autoPublish', {
    label: t('dlg-auto-publish'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement(Checkbox, {
        onChange: function onChange(value) {
          return handleChange(row.id, 'autoPublish', value);
        },
        checked: val
      });
    }
  });

  _.set(fields, 'autoUnpublishAfterStart', {
    label: t('dlg-auto-delist'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, {
        onChange: function onChange(value) {
          return handleChange(row.id, 'autoUnpublish', value);
        },
        checked: row.autoUnpublish
      }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Input, {
        key: "input-".concat(val),
        className: cx({
          'invalid': row.autoUnpublish && val === -1
        }),
        value: val > -1 ? val : '',
        validate: {
          pattern: /^\d+$/,
          t: function t(code, _ref) {
            var value = _ref.value;
            return et('txt-not-num');
          }
        },
        onChange: function onChange(value) {
          return handleChange(row.id, 'autoUnpublishAfterStart', value);
        }
      }), t('dlg-minutes-auto-delist')));
    }
  });

  return /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    data: typeList,
    fields: fields
  }));
});